import axiosWrapper from '@/utils/request'

const uploadFile = (taskId, token, data) => {
  return axiosWrapper({
    method: 'patch',
    url: `${process.env.VUE_APP_DRIP_API_HOST}/v1/platform/task_flows/${taskId}`,
    headers: {
      Authorization: 'Bearer ' + token
    },
    data
  })
}

export default {
  uploadFile
}
